import React from 'react';
import {View} from 'react-native';

import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import VolumePerformanceTestIDs from '/constant/TestIDs/VolumePerformance';

import {sanitize} from '../constants/volumePerformanceReport.constants';
import {styles} from '../styles/VolPerfResultsSortSection.style';
import {VolPerfResultsSortSectionProps} from '../types/VolPerfComponent.types';

export const VolPerfResultsSortSection: React.FC<
  VolPerfResultsSortSectionProps
> = ({
  resultsCount,
  onSortPress,
  sortByLabel = 'Sort : Default',
  selectedSortBy,
}) => {
  return (
    <View style={styles.container}>
      <Text
        testID={VolumePerformanceTestIDs.volPerfFrontlineResults}
        style={styles.resultsText}
        isBold
        emphasis="standard"
        accessible={true}
        accessibilityLabel={`${resultsCount} Results`}
        accessibilityRole="header">
        {resultsCount} Results
      </Text>
      <TouchableOpacity
        testID={`${VolumePerformanceTestIDs.volPerfSort}-${sanitize(
          selectedSortBy,
        )}`}
        style={styles.sortButton}
        onPress={onSortPress}
        accessible={true}
        accessibilityLabel={sortByLabel}
        accessibilityRole="button">
        <Icon name="sort" style={styles.sortIcon} />
        <Text
          style={styles.sortButtonText}
          isBold
          variant="button"
          emphasis="standard"
          numberOfLines={1}
          ellipsizeMode="tail">
          {sortByLabel}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

export default VolPerfResultsSortSection;
